import React, { useState } from 'react';
import DeliveryAddressView from '../../Presentation/AddressesAndStores/DeliveryAddressView';
import { useDispatch } from 'react-redux';
import { deleteAddress } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import AlertFormInsideModel from 'molecules/Alert';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { toastifyFn } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import AddressModalContainer from 'organisms/AddressModel/Container/AddressModalContainer';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';

const DeliveryAddressContainer = props => {
  const dispatch = useDispatch();
  const { savedAddresses, tenantId } = props;
  const { NO_ADDRESS, DELETE_CONFIRM_MSG, CANCEL, YES_DELETE, MYDELIVERYADDRESSES, DELIVERY_ADD_DELETE } =
    TRANSLATE_MAPPING_KEY;

  const [openModal, toggleModal] = useState(false);
  const [modalType, setModalType] = useState(false);
  const [address, setAddress] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [addressId, setAddressId] = useState(null);

  const deleteAddressHandler = () => {
    setAddressId(null);
    const { customerId, phoneNumber } = AuthManager.getInstance();
    dispatch(
      deleteAddress({
        customerId,
        phoneNumber,
        tenantId,
        addressId,
      }),
    );
    setShowAlert(false);
    toastifyFn(translateWithI18Next(DELIVERY_ADD_DELETE), '', 'favorites-added-toast');
  };

  const addOrEditClickHandler = (type, addressDetails = {}) => {
    const mode = type === 'edit' ? true : false;
    setAddress(addressDetails);
    toggleModal(true);
    setModalType(mode);
  };

  return (
    <div className='delivery-address-section' style={{ 'margin-top': '70px' }}>
      <div className='header-text'>
        {translateWithI18Next(MYDELIVERYADDRESSES)} {`(${savedAddresses.length})`}
      </div>
      {savedAddresses.length === 0 && (
        <div className='no-fav-store'>
          <p>{translateWithI18Next(NO_ADDRESS)}</p>
        </div>
      )}
      <DeliveryAddressView
        savedAddresses={savedAddresses}
        addOrEditClickHandler={addOrEditClickHandler}
        deleteAddressHandler={address_id => {
          setShowAlert(true);
          setAddressId(address_id);
        }}
      />
      {openModal && (
        <AddressModalContainer
          data-testid='address-modal'
          modalType={modalType}
          address={address}
          isOpen={openModal}
          toggleModal={toggleModal}
        />
      )}
      {showAlert && (
        <AlertFormInsideModel
          handleClose={() => setShowAlert(false)}
          classNames='plp-warning-msg addr-container'
          CartAlertForm={
            <AlertForm
              title={`${translateWithI18Next(DELETE_CONFIRM_MSG)}`}
              imageSrc={IMAGE_PATH.CartErrorIcon}
              confirmButtonText={translateWithI18Next(YES_DELETE)}
              confirmHandler={deleteAddressHandler}
              cancelHandler={() => setShowAlert(false)}
              cancelButtonText={translateWithI18Next(CANCEL)}
              buttonContainerClass='deeplink-alert-btn-container'
            />
          }
        />
      )}
    </div>
  );
};

export default DeliveryAddressContainer;
